function PropertiesController(){
	this.className	= "PropertiesController";
	this.glob		= [
		'/property-management**',
		'/property-sourcing**',
		'/property-search**',
		'/settling-in**',
		'/home-management**',
		'/service**'
	];
	this.debug		= false;
	this.priority 	= 10;
	// this.globMain			= true;
};
PropertiesController.inheritsFrom( StandardController );
PropertiesController.prototype.swap = function(onComplete){

	this.$body				= $("body").find(".js-body");
	this.$page 				= this.$body.find(".js-page");
	this.baseController 	= Aviator.get("baseController");
	this.isMobile			= this.baseController.isMobile();

	this.pageWrapper 		= document.querySelector('.page-wrapper');
	console.log(this.pageWrapper, 'this.pageWrapper');

	this.caseStudiesPagination = 0;

	this.$loadMoreLink 		= this.$page.find('.js-load-more-link');
	this.$loadingMessage 	= this.$page.find('.js-loading-message');
	this.$caseStudies 		= this.$page.find('.js-case-studies');
	console.log(this.$loadMoreLink, 'this.$loadMoreLink');
	this.$loadMoreLink.on('click', (e) => {
		console.log('click load');
		this.loadMoreCaseStudies();
	});

	this.updatePageSideMenu();
	console.log('swap property load');

	// this.revealImageAnimations('.js-animate--image-reveal');
	// this.revealContentAnimations('.js-animate--content-reveal', '.topic-copy');
	// this.revealFeatureAnimations('#feature-module-1');

	console.log('swap property load');
    
	setTimeout(() => onComplete(), 10);
	
    return false;
};
/*
PropertiesController.prototype.swapMain = function(onComplete){
	console.log('swap property main');
}
*/
PropertiesController.prototype.on = function(onComplete){
	this.openCaseStudyGetScrollPosition();
	return true;
}
PropertiesController.prototype.off = function(){};

PropertiesController.prototype.revealImageAnimations = function(container) {
	const containers = document.querySelectorAll(`${container} .img-replace`);
	containers.forEach((container, index) => {
		const items = [];

		const className = container.className.match(/img-replace-\d+/);
		const containerSelector = `.${className}`;

		const item = document.querySelector(containerSelector);
		if (!item) return;

		item.classList.add("animation-reveal");
		console.log(containerSelector);

		items.push({
			selector: containerSelector,
			onEnter: () => {
				setTimeout(() => {
					item.classList.add("animation-reveal--active");
				}, 100);
			}
		});

		new AnimationController({
			containerSelector: containerSelector,
			triggerStart: 'top 90%',
			triggerEnd: 'top top',
			showMarkers: false,
			once: true,
			onScroll: false,
			items: items,
		});
	});
}

PropertiesController.prototype.revealContentAnimations = function(containerSelector, elementSelector) {
	document.querySelectorAll(containerSelector).forEach((container, index) => {
		const childElements = container.querySelectorAll(`#${container.id} ${elementSelector} h4`);
		for(let i = 1; i <= childElements.length; i++) {
			const items = [];
			const index = i + 1;

			const itemSelector = `
				#${container.id} ${elementSelector} h4:nth-of-type(${index}),
				#${container.id} ${elementSelector} p:nth-of-type(${index})
			`;

			let containerSelector = itemSelector;
			if(!this.isMobile) containerSelector = `#${container.id} ${elementSelector}`;

			new AnimationController({
				containerSelector: containerSelector,
				triggerStart: 'top 90%',
				triggerEnd: 'top top',
				showMarkers: false,
				once: true,
				onScroll: false,
				items: [{
					selector: itemSelector,
					start: { opacity: 0 },
					end: { opacity: 1 },
					options: {
						duration: .5,
						delay: this.isMobile ? 0 : i * .5,
					}
				}],
			});
		}
	});
}

PropertiesController.prototype.revealFeatureAnimations = function(element) {
	const featureModule1 = document.querySelector(element);
	if (!featureModule1) return;

	const items = featureModule1.querySelectorAll('.js-animate-item');
	items.forEach((item, index) => {
		const i = index + 1;
		let selector = `${element} .js-animate-item`;
		if(this.isMobile) selector = `${element} .js-animate-item:nth-of-type(${i})`;
		new AnimationController({
			containerSelector: selector,
			triggerStart: 'top 90%',
			triggerEnd: 'top top',
			showMarkers: false,
			once: true,
			onScroll: false,
			items: [{
				selector: selector,
				start: { opacity: 0 },
				end: { opacity: 1 },
				options: {
					duration: 0.5,
					stagger: 0.25
				}
			}],
		});
	});
}


PropertiesController.prototype.updatePageSideMenu = function() {
	if(this.scrollEvent) removeEventListener('scroll', this.scrollEvent);

	const $pageSections = this.$page.find('.js-page-section');
	const $menuSections = this.$page.find('.js-menu-section');
	const $pageSideMenu = this.$page.find('.js-page-side--menu');
	const $sideMenuItems = $pageSideMenu.find('.js-menu--item');
	const $sideMenuLinks = $pageSideMenu.find('.js-menu--link');

	// console.log('menu sections! ', $menuSections);
	// console.log('page side menu! ', $pageSideMenu);
	// console.log('side menu items! ', $sideMenuItems);
	// console.log('side menu linsk! ', $sideMenuLinks);

	this.scroll = (e) => {
		const $currentSection = $menuSections.filter((index, section) => {
			const $sideMenuItem = $sideMenuItems.eq(index);
			if(!$sideMenuItem.length) return;

			// console.log("Found menu item:", index, $sideMenuItem);

			const offset = section.getBoundingClientRect();
			return (
				offset.top < (window.innerHeight) && offset.bottom > (window.innerHeight / 2) //offset.height
				||
				index === $menuSections.length - 1 && offset.top < (window.innerHeight / 2)
			);
		});

		// Swap menu classes
		let sectionIndex = $menuSections.index($currentSection);

		// console.log('sectionIndex', sectionIndex);

		const $sideMenuItem = $sideMenuItems.eq(sectionIndex);

		// console.log('sss ',$sideMenuItem);

		if ($sideMenuItem.length) {
			$sideMenuLinks.removeClass('menu__link--active');

			// Swap sections classes
			$menuSections.removeClass('is-active');
			$currentSection.addClass('is-active');

			// console.log('sectionIndex', sectionIndex);

			sectionIndex = sectionIndex < 0 ? 0 : sectionIndex;
			$sideMenuItems.eq(sectionIndex).find('.js-menu--link').addClass('menu__link--active');
		}
	}

	this.scrollEvent = () => this.scroll();
	addEventListener('scroll', this.scrollEvent);
}

PropertiesController.prototype.loadMoreCaseStudies = function() {
	this.$loadMoreLink.toggleClass('hide');
	this.$loadingMessage.toggleClass('hide');

	this.caseStudiesPagination++;
	const loadCaseStudiesPromise = this.ajax({
		pagination: this.caseStudiesPagination,
	});

	loadCaseStudiesPromise.then(caseStudies => {
		if (caseStudies) {
			let $caseStudy = false;

			caseStudies.forEach((newCaseStudy, newCaseStudyIndex) => {
				this.addPropertyToDom(newCaseStudy, newCaseStudyIndex%3);
				if(newCaseStudyIndex === 0) $caseStudy = this.$caseStudies.find(".js-case-study:last-child");
			});

			Aviator.get("baseController").getImageController().$process(this.$caseStudies);

			var st = $caseStudy.offset().top - 30;
			$('html, body').animate({
				scrollTop: st
			}, 750);

		} else {
			this.$loadMoreLink.hide();
		}
	})
}
PropertiesController.prototype.ajax = function(data) {
  return $.ajax({
    url: `/${nav.part(0)}/more/`,
    data: data,
    method: "post"
  }).then(result => {

	  console.log('ajax');
    const json = JSON.parse(result);
    const items = json['case_studies'];

    this.$loadMoreLink.toggleClass('hide');
    this.$loadingMessage.toggleClass('hide');

    if(!json['has_more_case_studies']) this.$loadMoreLink.hide();
		
    return items;
  })
}
PropertiesController.prototype.addPropertyToDom = function(caseStudy, mod) {
	const template = this.getTemplates()['case-study'];
	var html = Mustache.render(template.html,caseStudy);

	//For image preloading
	html = html.replace(/\<img\ src=/g,"<img src-wait=");

	this.$caseStudies.append(html);
}
PropertiesController.prototype.openCaseStudyGetScrollPosition = function() {
	$('.js-services-case-study').on('click', (e) => {
		e.preventDefault();
		this.scrollPosition = window.scrollY;
		this.pageWrapper.setAttribute('data-csscroll', this.scrollPosition);
	});

	this.scrollPosition = this.pageWrapper.getAttribute('data-csscroll');
	if(this.scrollPosition && !document.querySelector('.js-body-cs')) {
		$('html, body').scrollTop(this.scrollPosition);
		this.pageWrapper.removeAttribute('data-csscroll');
	}
};
PropertiesController.prototype.off = function(){
	if(this.scrollEvent) removeEventListener('scroll', this.scrollEvent);
}
